import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { PageNotificationService } from './page-notification';
import { CommonService } from './common.service';
import { CodescDTO } from '@signature-it/ngx-generic/models';
import {shareReplay} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class CodescService extends CommonService {

    protected gbvUrl = `${this.publicBaseUrl}/codesc`;
    protected gdbvUrl = `${this.publicBaseUrl}/data/codesc`;
    protected codesc: {} = {};

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService) {
        super(http, restUrlsConf, notifySvc);
    }

    /**
     * @param _var string
     * @returns Observable<CodescDTO[]>
     */
    getByVar(_var: string): Observable<CodescDTO[]> {
        return this.http.get<CodescDTO[]>(`${this.gbvUrl}/${_var}`);
    }

    getByVarOnce(_var: string) {
        if(!this.codesc[_var]) {
            this.codesc[_var] = this.getByVar(_var).pipe(
                shareReplay(1)
            );
        }
        return this.codesc[_var];

    }

    getDataByVar(_var: string): Observable<any> {
        return this.http.get(`${this.gdbvUrl}/${_var}`);
    }
}
